
import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function HeroSection() {
  const { t } = useTranslation('method');
  const { ref: contentRef, isVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section className="relative min-h-[80vh] flex items-end overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/9cb4ac9ececb8e0246f86a91baeb3d1b.jpg"
          alt="Método FGT"
          className="w-full h-full object-cover object-center"
        />
      </div>
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B]/95 via-[#0B0B0B]/55 to-[#0B0B0B]/10"></div>
      {/* Accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-[#F97700]"></div>

      {/* Content */}
      <div ref={contentRef} className="relative z-10 w-full max-w-7xl mx-auto px-6 pb-24 pt-48">
        <div className="max-w-5xl mx-auto text-center">
          <p
            className="text-xs font-semibold tracking-[0.3em] uppercase text-[#F97700] mb-6 transition-all duration-700"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(24px)',
              transitionDelay: '0ms',
            }}
          >
            {t('hero.label')}
          </p>
          <h1
            className="text-5xl md:text-7xl font-semibold text-white leading-[1.05] mb-8 drop-shadow-lg tracking-tight transition-all duration-700"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(28px)',
              transitionDelay: '120ms',
            }}
          >
            {t('hero.title')}
          </h1>
          <p
            className="text-xl text-white/75 leading-relaxed max-w-2xl mx-auto mb-10 italic transition-all duration-700"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(24px)',
              transitionDelay: '240ms',
            }}
          >
            {t('hero.subtitle')}
          </p>
          <p
            className="text-base text-white/60 leading-relaxed max-w-xl mx-auto transition-all duration-700"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
              transitionDelay: '340ms',
            }}
          >
            {t('hero.description')}
          </p>

          {/* Stats row */}
          <div
            className="mt-16 grid grid-cols-3 gap-8 max-w-2xl mx-auto border-t border-white/15 pt-10 transition-all duration-700"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
              transitionDelay: '460ms',
            }}
          >
            {(t('hero.stats', { returnObjects: true }) as Array<{ value: string; label: string }>).map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-3xl font-semibold text-[#F97700] mb-1">{stat.value}</div>
                <div className="text-xs text-white/50 uppercase tracking-wider">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
